'use client'

import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

import { menuContent } from './Menu'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

export const PopoverAnchor = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Anchor>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Anchor>
>((props, ref) => {
  return <PopoverPrimitive.Anchor {...props} ref={ref} />
})
PopoverAnchor.displayName = 'PopoverAnchor'

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    portalled?: boolean
  }
>(({ className, align = 'start', sideOffset = 4, portalled = true, onWheel, onTouchMove, ...props }, ref) => {
  const Wrapper = portalled ? PopoverPrimitive.Portal : React.Fragment
  return (
    <Wrapper>
      <PopoverPrimitive.Content
        align={align}
        className={menuContent({ className })}
        // A dialog locks page scrolling with its own copy of react-remove-scroll,
        // which does not know this portalled popover and cancels wheel and touch
        // scrolling inside it. Its listener is on the document, so keeping the
        // events inside the popover lets its list scroll.
        onTouchMove={(event) => {
          onTouchMove?.(event)
          event.stopPropagation()
        }}
        onWheel={(event) => {
          onWheel?.(event)
          event.stopPropagation()
        }}
        ref={ref}
        sideOffset={sideOffset}
        {...props}
      />
    </Wrapper>
  )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverContent, PopoverTrigger }
